import "./Badge.scss";
import UserIcon from "./icons/UserIcon";

export interface UserBadgeProps {
  name: string;
}

function getInitials(name: string): string {
  name = name.replace(/\s+/g, ' ').trim();

  if (!name) return "";

  const bits = name.split(" ");

  if (bits.length === 1) {
    return bits[0][0].toUpperCase();
  } else {
    return `${bits[0][0]}${bits[1][0]}`.toUpperCase();
  }
}

export default function UserBadge({ name }: UserBadgeProps) {
  return (
    <div className={"name-badge"}>
      {getInitials(name) === "" ? <UserIcon /> : getInitials(name)}
    </div>
  );
}
